// extracted by mini-css-extract-plugin
export var oSolution = "solution-module--o-solution--2nsNu";
export var oSolution__message = "solution-module--o-solution__message--3NpNE";
export var visible = "solution-module--visible--1wlFX";
export var lContent__inner = "solution-module--l-content__inner--N_Bci";
export var standby = "solution-module--standby--3aSxi";